import { createPersistentStorage } from "@/script/storage/storage-factory"

export default createPersistentStorage("tcf.local", {
	markers: [],
})
